import { fetchUrlTelerik } from "./http-common";

const exportaReporte = (data = {}) => {
    return fetchUrlTelerik.post(`/v1/exportarReporte`, data);
}

const reporteServicio = {
    exportaReporte,
}

export default reporteServicio;